import axios from 'axios'

export default {
	data() {
		return {
			items: [],
			search: '',
			globalLoading: true,
			domain: '',
			checkBoxValue: [],
			loading: true,
			dateCreate: Date.now(),
			sortable: false,
			can: false,
			copyrightPanel: false,
			activePage: 1,
			whereIs: new Object,
			navigation: [],
			send: this.$store.getters.getDomainName+ 'core/get/'+this.$route.name,
			routerName: this.$route.name,

		}
	},

	created() {
		if(this.$route.query.page != 1 && this.$route.query.page != undefined) {
			this.activePage = this.$route.query.page
		}

		this.getItems()


	},

	methods: {

		getItems() {

			this.domain =  this.$store.getters.getDomainName
			this.loading = true;

			if(this.routerName == 'soft-material-parent' && this.$route.params.id) {
				this.whereIs['parent_id'] = this.$route.params.id
			}

			// if(this.routerName == 'shop-option-parent' && this.$route.params.id) {
			// 	this.whereIs['parent_id'] = this.$route.params.id
			// }

			// if(this.routerName == 'soft-parent' && this.$route.params.id) {
			// 	this.whereIs['parent_id'] = this.$route.params.id
			// }

		

			if(this.routerName == 'shop-module-sofa-product' && this.$route.params.id) {
				this.whereIs['product_id'] = this.$route.params.id
			}

			if(this.routerName == 'soft-element' && this.$route.params.id) {
				this.whereIs['soft_group_id'] = this.$route.params.id
			}

			if(this.routerName == 'soft-module-product' && this.$route.params.id) {
				this.whereIs['shop_product_id'] = this.$route.params.id
			}

			// if(this.routerName == 'shop-module-view-parent' && this.$route.params.id) {
			// 	this.whereIs['category_id'] = this.$route.params.category
			// 	this.whereIs['parent_id'] = this.$route.params.id
			// }

			// if(this.routerName == 'shop-module-view' && this.$route.params.id) {
				
			// 	this.whereIs['category_id'] = this.$route.params.category
			// }

			// if(this.routerName == 'shop-module-view' && this.$route.params.category) {

			// 	this.whereIs['category_id'] = this.$route.params.category
			// }

			if(this.$route.params.param1) {
				var send = this.$store.getters.getDomainName+ 'admin/get/'+this.routerName + '/' + this.$route.params.param1 + '?page='+this.activePage

			} else {
				var send = this.$store.getters.getDomainName+ 'admin/get/'+this.routerName + '?page='+this.activePage
			}


			axios.post(send, {
				where: this.whereIs
			})

			.then(response => {


				this.items =  response.data
				this.navigation =  response.data.menus.navigation
				this.can =  response.data.can
				

				this.activePage = this.items.current_page

				this.routerName = this.$route.name
				
				this.loading = false
				this.globalLoading = false

				for (var i = 0; i < this.items.data.length; i++) {

					var img = this.items.data[i].images
					var mainImage = img.split(';')

					this.items.data[i]['images'] = mainImage[0]
					alert
					this.items.data[i]['check'] = false

					for (var j = this.checkBoxValue.length - 1; j >= 0; j--) {

						if(this.checkBoxValue[j].id == this.items.data[i].id) {
							this.items.data[i]['check'] = true
						}
					}
				}

				

			})
			
			.catch(error => { 
				// this.$router.push({ name: '404' })

				this.loading = false;

				this.sortable = true

			})

		},

		searchItems() {

			if(this.search.trim().length === 0) {
				this.sortable = true
			} else {
				this.sortable = false
			}

			axios.post(this.domain+'core/search/'+this.dataBase.table, {
				value: this.search
			})

			.then(response => {

				this.items = response.data

				console.log(this.items.data.length)

				for (var i = 0; i < this.items.data.length; i++) {
					var mainImage = response.data.data[i]['images'].split(';')
					this.items.data[i]['images'] = mainImage[0]

					//this.items.data[i]['status'] == 1 ? this.items.data[i]['status'] = 'Активен' : this.items.data[i]['status'] = 'Изключен' 
				}
			})
			.catch(error => { })

		},

		changeFilter(data) {
			this.sortable = false
			this.dataBase.find = data
			this.getItems()
		},
		changeStatus(id) {
			axios.get(this.domain+'core/status/'+this.dataBase.table+'/'+id)
			.then(response => {
				var el = this.items.data.filter(item => item.id == id)
				el[0].status = response.data

			})
		},
		changeStateCheckbox(id) {

			var el = this.checkBoxValue.filter(item => item.id == id)

			var check = true;
			for(var i = 0;i < this.checkBoxValue.length;i++) {

				if(this.checkBoxValue[i].id == id) {

					this.checkBoxValue.splice(i, 1)
					var check = false;
				}
			}
			console.log(this.checkBoxValue)
			if(check) {
				this.checkBoxValue.push({
					id: id
				})
			}


			console.log(this.checkBoxValue)

		},

		massActItem(act) {

			axios.post(this.domain+'core/mass/'+this.routerName+'/'+act, {
				checked: this.checkBoxValue
			})

			.then(response => {
				console.log(response.data)
				for(var i = 0;i < this.checkBoxValue.length;i++) {

					for (var j = this.items.data.length - 1; j >= 0; j--) {
						if(this.items.data[j].id == this.checkBoxValue[i].id) {
							if(response.data == 'removed') {
								this.items.data.splice(j, 1)

							} else if(response.data == 'on') {
								this.items.data[j].status = 1;
							} else if(response.data == 'off') {
								this.items.data[j].status = 0

							} else {
								this.items.data[j]['check'] = false
								
								this.items.data.unshift(response.data) 
							}


						}
						this.items.data[j]['check'] = false

					}
				}
				this.checkBoxValue = []
				iziToast.show({
					
					color: 'dark',
					icon: 'fa fa-envelope-open-o',
					title: 'System',
					message: 'Success! Thanks, Well done!',
					position: 'topRight', 
					progressBarColor: '#777',

				});
			})
			.catch(error => { })

		},
		oneActItem(id,act) {
			var continueQuestion = confirm("Are you sure?");

			if(!continueQuestion) {
				return
			}

			this.checkBoxValue = []

			this.checkBoxValue.push({
				id: id
			})

			this.massActItem(act)
		},
		checkAll() {

			if(this.checkBoxValue.length == 0) {
				this.checkBoxValue = []

				for (var j = this.items.data.length - 1; j >= 0; j--) {
					this.checkBoxValue.push({
						id: this.items.data[j].id
					})
					this.items.data[j]['check'] = true
				}
			} else {
				this.checkBoxValue = []
				for (var j = this.items.data.length - 1; j >= 0; j--) {

					this.items.data[j]['check'] = false
				}

			}
			
			console.log(this.checkBoxValue)

		},
		changePageNumber(data) {
			var number = 1;
			// this.globalLoading = true

			if(data == 'prev') {
				if(this.items.prev_page_url) {
					this.activePage = this.activePage - 1

				}
			}
			else if(data == 'next') {
				if(this.items.next_page_url) {
					this.activePage = this.activePage + 1

				}
			} else if (!isNaN(parseFloat(number)) && !isNaN(number - 0)) {
				
			}


			this.getItems()

			// this.globalLoading = false


			// var redirect = this.$store.getters.getDomainName + this.$route.path + '?page=' + number

			window.history.pushState('page2', 'Title', '?page=' + this.activePage);

		},
		exportItems(where) {
			// this.globalLoading = true
				// this.routerName =this.$route.name
				// this.activePage = 1
				
				this.whereIs = where
				this.globalLoading = true
				this.routerName =this.$route.name
				this.activePage = 1
				
				this.getItems()
			}
		},
		computed: {

			checkBoxesState() {
				return this.checkBoxValue.length
			}
		},



		watch: {
			'$route' (to, from) {

				if(this.$route.name != this.routerName) {
					this.globalLoading = true
					this.routerName =this.$route.name

					this.activePage = 1

					this.whereIs = new Object()
					


					console.log(this.whereIs)
					console.log(this.whereIs)
					console.log(this.whereIs)
					console.log(this.whereIs)

					this.getItems()

				}

      // alert(this.$store.getters.getDomainName+ 'core/get/'+this.$route.name)
  },
  items() {
			// alert(this.sortable)
			// if(this.sortable) {
			// 	alert('222')
			// 	axios.post(this.domain+'core/sortable/'+this.dataBase.table, this.items.data)

			// 	.then(response => {
			// 		console.log(response.data)

			// 	})
			// 	.catch(error => {

			// 	})
			// }

		},

	},


}


// WEBPACK FOOTER //
// ./src/mixins/database.js